import { getCookie, setCookie, updateCookie, text_truncate } from '../core/utils.js';
import { trialButton } from './trial-buttons.js';
import { tourButton } from './product-tour-buttons.js';

var code = '',
  ccode = '',
  leads_referrer = document.referrer;

export function setCampaignInfo() {
  var url_string = window.location.href;
  var url = new URL(url_string);
  var gclid = url.searchParams.get('gclid') || getCookie('gclid') || '';
  var msclkid = url.searchParams.get('msclkid') || getCookie('msclkid') || '';
  var utmsource = url.searchParams.get('utm_source') || getCookie('utm_source') || '';
  var utmmedium = url.searchParams.get('utm_medium') || getCookie('utm_medium') || '';
  var utmcampaign = url.searchParams.get('utm_campaign') || getCookie('utm_campaign') || '';
  var utmterm = url.searchParams.get('utm_term') || getCookie('utm_term') || '';
  var matchtype = url.searchParams.get('matchtype') || getCookie('matchtype') || '';
  var campaignid = url.searchParams.get('campaign_id') || getCookie('campaign_id') || '';
  var channel = url.searchParams.get('channel') || '';
  var journey = '';
  var gaid = getCookie('_ga');
  var campaign_info = '';
  var campaign_jn = '';
  var gclidmsclkid = '';
  var isBlog = false;
  var pageIdEl = document.querySelector('#page_id');
  var pageId = (pageIdEl && pageIdEl.value) ? pageIdEl.value : '';
  var devicetype = '|(W)';
  var sleekr_journey = '';

  // variable untuk new waba format
  var waba_medium = getCookie('waba_code') || (typeof code !== 'undefined' ? code : '');
  var waba_campaign = getCookie('wabac_code') || (typeof ccode !== 'undefined' ? ccode : '');
  var last_medium = getCookie('last_medium_id') ? getCookie('last_medium_id') : '';
  var last_campaign = getCookie('last_campaign_id') ? getCookie('last_campaign_id') : '';
  var last_gclid = getCookie('last_gclid') ? getCookie('last_gclid') : '';

  // variable untuk query keyword
  var query_keyword = url.searchParams.get('query') || 'null';
  var last_query_keyword = getCookie('last_query_keyword') ? getCookie('last_query_keyword') : '';

  if (window.__jurnalWabaDebug) console.log('[mlat keyword] URL ?query=', url.searchParams.get('query'), '| cookie query_keyword=', getCookie('query_keyword'), '| cookie last_query_keyword=', getCookie('last_query_keyword'));

  // TIMESTAMMP
  var tt_date = new Date();
  var tt_month_base = tt_date.getMonth() + 1;
  var tt_month = (tt_month_base < 10 ? '0' : '').toString() + tt_month_base;
  var tt_day = (tt_date.getDate() < 10 ? '0' : '').toString() + tt_date.getDate();
  var tt_hour = (tt_date.getHours() < 10 ? '0' : '').toString() + tt_date.getHours();
  var tt_minutes = (tt_date.getMinutes() < 10 ? '0' : '').toString() + tt_date.getMinutes();
  var j_timestamp = tt_month.toString() + tt_day.toString() + tt_hour.toString() + tt_minutes.toString();

  // BANNER ID
  var today = new Date();
  var year = today.getFullYear().toString().slice(-2);
  var month = (today.getMonth() + 1).toString();
  if (month.length === 1) {
    month = '0' + month;
  }
  var formattedDate = year + month;

  if (waba_medium) {
    code = waba_medium;
  }

  if (waba_campaign) {
    ccode = waba_campaign;
  }

  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      navigator.userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      navigator.userAgent.substr(0, 4)
    )
  ) {
    devicetype = '|(M)';
  } else {
    devicetype = '|(W)';
  }

  // function untuk format journey yg baru
  var resultsDate = tt_day.toString() + tt_month.toString() + tt_hour.toString() + tt_minutes.toString();

  var newUtmCamp = pageId.replace(/Blog/gm, '');
  var utermmatchtype;
  var getParamMatchtype = url.searchParams.get('matchtype') || '';
  var getParamUtmterm = url.searchParams.get('utm_term') || '';
  var getParamUtmsource = url.searchParams.get('utm_source') || '';
  var getParamUtmmedium = url.searchParams.get('utm_medium') || '';
  var getParamUtmcampaign = url.searchParams.get('utm_campaign') || '';

  if (
    getCookie('sr') != '' &&
    getCookie('sr') != null &&
    getCookie('sr') != undefined &&
    (typeof is_sr !== 'undefined' && is_sr == 'false')
  ) {
    if (getParamUtmterm == '') {
      var srTerm = 'SR ' + getCookie('sr');
      getParamUtmterm = srTerm;
      if (!utmterm) utmterm = srTerm;
      setCookie('sr', '', 0);
    }
  }

  // utermmatchtype (written into the journey entry itself) reflects ONLY
  // what's in THIS page's own URL — not the cookie-persisted utm_term/
  // matchtype (which the click-tracking/matching logic elsewhere still
  // reads via the utmterm/matchtype vars above). Otherwise, since utm_term
  // now persists via cookie across the whole visit, every single journey
  // entry (one per page visited) would repeat the same original term —
  // it should only appear once, on the entry for the page that actually
  // carried it in its URL.
  if (getParamUtmterm != '' || getParamMatchtype != '') {
    utermmatchtype = '.' + getParamMatchtype + '.' + getParamUtmterm;
  } else {
    utermmatchtype = '..';
  }

  if (last_medium != '' || last_campaign != '') {
    if (last_medium != waba_medium || last_campaign != waba_campaign) {
      updateCookie('last_medium_id', waba_medium);
      updateCookie('last_campaign_id', waba_campaign);
      var newJourney = newUtmCamp + '.' + resultsDate + '.' + waba_medium + waba_campaign + utermmatchtype;
    } else {
      if (getCookie('user_journey')) {
        var newJourney = newUtmCamp + '.' + resultsDate + '.' + utermmatchtype;
      } else {
        var newJourney = newUtmCamp + '.' + resultsDate + '.' + waba_medium + waba_campaign + utermmatchtype;
      }
    }
  } else {
    setCookie('last_medium_id', waba_medium, 31);
    setCookie('last_campaign_id', waba_campaign, 31);
    var newJourney = newUtmCamp + '.' + resultsDate + '.' + waba_medium + waba_campaign + utermmatchtype;
  }

  if (getCookie('devicetype')) {
    if (getCookie('banner_click')) {
      if (!getCookie('devicetype').includes(getCookie('banner_click'))) {
        devicetype = devicetype + getCookie('banner_click');
        updateCookie('devicetype', devicetype);
      } else {
        devicetype = devicetype + getCookie('banner_click');
      }
    } else {
      if (!getCookie('devicetype').includes(formattedDate)) {
        updateCookie('devicetype', devicetype);
      } else {
        devicetype = devicetype + formattedDate;
        updateCookie('devicetype', devicetype);
      }
    }
  } else {
    if (getCookie('created_at')) {
      updateCookie('devicetype', devicetype);
    } else {
      setCookie('devicetype', devicetype, 31);
    }
  }

  // function ini untuk membuat query keyword journey
  if (last_query_keyword == '') {
    last_query_keyword = query_keyword ? query_keyword : 'null';
    setCookie('last_query_keyword', last_query_keyword, 90);
    if (window.__jurnalWabaDebug) console.log('[mlat keyword] first visit → set last_query_keyword=', last_query_keyword);
  }

  if (!getCookie('query_keyword')) {
    setCookie('query_keyword', query_keyword, 90);
    if (window.__jurnalWabaDebug) console.log('[mlat keyword] no existing cookie → set query_keyword=', query_keyword);
  } else {
    var last_pageId_q = /[^|]*$/.exec(getCookie('user_journey') || '')[0] || '';
    var last_pageId_q_pid = last_pageId_q.split('.')[0];
    var samePage_q = pageId && last_pageId_q_pid && pageId.includes(last_pageId_q_pid);
    if (window.__jurnalWabaDebug) console.log('[mlat keyword] existing cookie=', getCookie('query_keyword'), '| pageId=', pageId, '| last_pageId_q=', last_pageId_q, '| samePage_q=', samePage_q);
    // Only ever append a NEW entry when this page actually carries a real
    // (non-'null') ?query= value that's different from the last one seen —
    // 'null' (no ?query= on this page) must never itself be appended, or the
    // accumulator fills up with '...|null|null|...' on plain navigation
    // between pages that don't carry a query param. That corrupted value is
    // no longer the literal 'null' sentinel, so downstream code (Query
    // Keyword Chat Templates' query_search_term-vs-utm_term fallback) treats
    // it as "a real query" and never falls back to utm_term. When this page
    // has no real query, just keep the accumulator as-is.
    if (!samePage_q) {
      if (query_keyword !== 'null' && query_keyword != last_query_keyword) {
        updateCookie('last_query_keyword', query_keyword);
        query_keyword = getCookie('query_keyword') + '|' + query_keyword;
        updateCookie('query_keyword', query_keyword);
        if (window.__jurnalWabaDebug) console.log('[mlat keyword] new page + new keyword → query_keyword=', query_keyword);
      } else {
        query_keyword = getCookie('query_keyword');
        if (window.__jurnalWabaDebug) console.log('[mlat keyword] new page + no/same keyword → keep query_keyword=', query_keyword);
      }
    } else {
      if (query_keyword !== 'null' && query_keyword != last_query_keyword) {
        updateCookie('last_query_keyword', query_keyword);
        query_keyword = getCookie('query_keyword') + '|' + query_keyword;
        updateCookie('query_keyword', query_keyword);
        if (window.__jurnalWabaDebug) console.log('[mlat keyword] same page + new keyword → query_keyword=', query_keyword);
      } else {
        query_keyword = getCookie('query_keyword');
        if (window.__jurnalWabaDebug) console.log('[mlat keyword] same page + no/same keyword → no update, query_keyword=', query_keyword);
      }
    }
  }
  if (window.__jurnalWabaDebug) console.log('[mlat keyword] FINAL query_keyword=', query_keyword);

  // function ini untuk memasukkan format journey baru ke cookie journey
  if (getCookie('user_journey')) {
    journey = getCookie('user_journey');

    if (sleekr_journey != '') {
      journey = sleekr_journey + '|' + journey;
    }

    var last_pageId = /[^|]*$/.exec(journey)[0] || '';
    var lastParts = last_pageId.split('.');
    var lastPid = lastParts[0] || ''; // pageId terakhir
    var lastCode = lastParts[2] || ''; // kode channel terakhir (waba_medium + waba_campaign)

    var samePage = pageId && lastPid && pageId.includes(lastPid);
    var codeChanged = waba_medium && lastCode && !lastCode.includes(waba_medium);

    var nowHasWaba = Boolean(waba_medium || waba_campaign);
    var lastHasWaba = Boolean(lastCode);
    var candidateEntry = newJourney + '.' + channel;

    // setCampaignInfo() legitimately runs more than once per page load:
    // waba-core.js calls it again via refreshCampaignInfo() shortly after
    // the first call, once initWabaTracking() settles, specifically so the
    // repair rule below can patch in the waba code once it's ready. But the
    // append decisions further down compare URL params against cookies that
    // OTHER trackers are still writing asynchronously in that same window —
    // so a second call can spuriously see a "change" that's really just
    // timing, and append a near-duplicate entry for the same visit. Only
    // the first call for this page load is allowed to decide to append;
    // later calls may only repair (which is idempotent/replace-in-place).
    var isFirstCallForPage = !window.__jurnalJourneyDecidedForPage;
    window.__jurnalJourneyDecidedForPage = true;

    // Repair rule (important for first interaction): if the last journey
    // entry was created before waba cookies existed, it may have an empty
    // code segment — replace it in place with the computed one.
    if (samePage && nowHasWaba && !lastHasWaba) {
      try {
        journey = journey.replace(/[^|]*$/, candidateEntry);
      } catch (e) {}
    } else if (isFirstCallForPage) {
      if (!samePage || codeChanged) {
        // Rule baru:
        // - Halaman beda  → selalu tambah journey baru.
        // - Halaman sama tapi kode channel berubah (Ads → Organic) → tetap tambah journey baru.
        journey += '|' + newJourney + '.' + channel;
      } else if (
        getParamUtmmedium !== '' ||
        getParamUtmcampaign !== '' ||
        getParamUtmterm !== '' ||
        getParamMatchtype !== '' ||
        channel !== ''
      ) {
        // Halaman sama, kode sama, tapi ada perubahan UTM → tetap tambah journey baru.
        if (
          getParamUtmmedium != getCookie('utm_medium') ||
          getParamUtmcampaign != getCookie('utm_campaign') ||
          getParamUtmterm != getCookie('utm_term') ||
          getParamMatchtype != getCookie('matchtype') ||
          channel !== ''
        ) {
          journey += '|' + newJourney + '.' + channel;
        }
      }
      // Halaman sama, kode sama, tidak ada perubahan UTM → jangan tambah journey (hindari spam).
    }

    if (getCookie('created_at')) {
      updateCookie('user_journey', journey);
    } else {
      setCookie('user_journey', journey, 31);
    }
  } else {
    // First-ever call for this page load (no user_journey cookie at all yet)
    // — mark the append decision as made so a subsequent same-page call
    // (see isFirstCallForPage above) doesn't also append a duplicate entry.
    window.__jurnalJourneyDecidedForPage = true;

    if (sleekr_journey != '') {
      journey = sleekr_journey + '|' + newJourney + '.' + channel;
    } else {
      journey = newJourney + '.' + channel;
    }
    setCookie('user_journey', journey, 31);

    if (getCookie('created_at') == '' || getCookie('created_at' == null) || getCookie('created_at' == undefined)) {
      var dateCookie = new Date();
      dateCookie.setTime(dateCookie.getTime() + 31 * 24 * 60 * 60 * 1000);
      setCookie('created_at', dateCookie.toUTCString(), 31);
    }
  }

  if (last_gclid == '') {
    last_gclid = gclid ? gclid : '';
    setCookie('last_gclid', gclid, 90);
  }

  // function ini untuk membuat gclid journey
  var gclid_journey = getCookie('gclid_journey') ? getCookie('gclid_journey') : '';

  if (gclid_journey == '') {
    setCookie('gclid_journey', gclid, 90);
  } else {
    if (gclid != last_gclid) {
      gclid_journey = gclid_journey + '|' + gclid;
      updateCookie('gclid_journey', gclid_journey);
      updateCookie('last_gclid', gclid);
    }
  }

  // Seleksi semua elemen yang sesuai selector
  var elementsAddsOn = document.querySelectorAll('.item .item__wrap[data-name*="AO"]');
  if (elementsAddsOn.length > 0) {
    elementsAddsOn.forEach(function (element) {
      element.addEventListener('click', function () {
        setCookie('addons', '', 0);
        var target = element.getAttribute('data-name');

        if (getCookie('addons')) {
          updateCookie('addons', '|' + target);
        } else {
          if (getCookie('created_at')) {
            updateCookie('addons', '|' + target);
          } else {
            setCookie('addons', '|' + target, 31);
          }
        }
      });
    });
  }
  var addons = getCookie('addons') || '';

  if (utmterm != '' && matchtype != '') {
    var uterm = '';
    uterm = ' @ ' + matchtype + '|' + utmterm;
    setCookie('termmatchtype', uterm, 31);
  } else if (getCookie('termmatchtype')) {
    var uterm = '';
    uterm = getCookie('termmatchtype');
  } else {
    var uterm = '';
    if (getCookie('utm_term') && getCookie('matchtype')) {
      uterm = ' @ ' + getCookie('matchtype') + '|' + getCookie('utm_term');
      setCookie('termmatchtype', uterm, 31);
    }
  }

  // ini untuk melimit journey baru
  var limit_journey = text_truncate(journey, 240);

  // Only treat as a new UTM event if URL actually contains UTM/GCLID params.
  // utm_term/matchtype must be included here too — otherwise a URL with ONLY
  // ?utm_term= (no utm_source/medium/campaign/gclid/msclkid) skips this whole
  // block, so the utm_term cookie (read as a fallback by Query Keyword Chat
  // Templates and Keyword Routing Patterns on later page views) never gets
  // written at all.
  const hasUtmParams = Boolean(
    url.searchParams.get('gclid') ||
    url.searchParams.get('msclkid') ||
    url.searchParams.get('utm_source') ||
    url.searchParams.get('utm_medium') ||
    url.searchParams.get('utm_campaign') ||
    url.searchParams.get('utm_term') ||
    url.searchParams.get('matchtype') ||
    url.searchParams.get('campaign_id')
  );

  if (hasUtmParams) {
    gclidmsclkid = text_truncate(gclid + '|' + msclkid, 250, '');

    var campaignInfo = JSON.parse(
      '{"gclid":"' +
        gclidmsclkid +
        '", "utm_source":"' +
        utmsource +
        '", "utm_medium":"' +
        utmmedium +
        '", "utm_campaign":"' +
        limit_journey +
        devicetype +
        '"}'
    );

    const stringifyCampaignInfo = JSON.stringify(campaignInfo);
    const cookiesCampaignInfo = encodeURIComponent(stringifyCampaignInfo);

    if (getCookie('created_at')) {
      updateCookie('campaign_info', cookiesCampaignInfo);
      updateCookie('j_campaign_info', cookiesCampaignInfo);
      updateCookie('gclid', gclid);
      updateCookie('msclkid', msclkid);
      updateCookie('utm_source', utmsource);
      updateCookie('utm_medium', utmmedium);
      updateCookie('utm_campaign', utmcampaign);
      updateCookie('utm_term', utmterm);
      updateCookie('matchtype', matchtype);
      updateCookie('campaign_id', campaignid);
    } else {
      setCookie('campaign_info', cookiesCampaignInfo, 31);
      setCookie('j_campaign_info', cookiesCampaignInfo, 31);
      setCookie('gclid', gclid, 31);
      setCookie('msclkid', msclkid, 31);
      setCookie('utm_source', utmsource, 31);
      setCookie('utm_medium', utmmedium, 31);
      setCookie('utm_campaign', utmcampaign, 31);
      setCookie('utm_term', utmterm, 31);
      setCookie('matchtype', matchtype, 31);
      setCookie('campaign_id', campaignid, 31);
    }
  } else {
    // No new UTM params in URL → keep existing UTM cookies untouched.
    // Still update campaign_info for visibility with the latest journey.
    var campaignInfo3 = JSON.parse(
      '{"gclid":"' + (getCookie('gclid') || '') + '", "utm_source":"' + (getCookie('utm_source') || '') + '", "utm_medium":"' + (getCookie('utm_medium') || '') + '", "utm_campaign":"' + limit_journey + devicetype + '"}'
    );

    const stringifyCampaignInfo3 = JSON.stringify(campaignInfo3);
    const cookiesCampaignInfo3 = encodeURIComponent(stringifyCampaignInfo3);
    if (getCookie('created_at')) {
      updateCookie('campaign_info', cookiesCampaignInfo3);
      updateCookie('j_campaign_info', cookiesCampaignInfo3);
    } else {
      setCookie('campaign_info', cookiesCampaignInfo3, 31);
      setCookie('j_campaign_info', cookiesCampaignInfo3, 31);
    }
  }

  if (gaid) {
    setCookie('gaid', '', 0);
    setCookie('gaid', gaid.slice(6), 31);
  } else {
    setCookie('gaid', '', 0);
  }

  trialButton();
  tourButton();
}

export function initCampaign() {
  // Ensure campaign/journey cookies exist before the first click.
  // Many handlers (WABA/Trial) read `user_journey` during the click event.
  // Using requestIdleCallback alone can delay it if the user interacts quickly.

  if (window.__jurnalInitCampaignScheduled) return;
  window.__jurnalInitCampaignScheduled = true;

  const run = () => {
    try { setCampaignInfo(); } catch (e) {}
  };

  const runAfterPaint = () => {
    try {
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(() => setTimeout(run, 0));
      } else {
        setTimeout(run, 0);
      }
    } catch (e) {
      setTimeout(run, 0);
    }
  };

  const ensureJourneyCookieFast = () => {
    // Fast-path: minimal work on the interaction thread to protect INP.
    // Only ensures `user_journey` is non-empty before click handlers read it.
    try {
      if (getCookie('user_journey')) return;
    } catch (e) {}

    try {
      const url = new URL(window.location.href);

      const pageIdEl = document.querySelector('#page_id');
      let pageId = (pageIdEl && pageIdEl.value) ? String(pageIdEl.value) : '';
      if (!pageId) {
        pageId = (window.location.pathname || '').replace(/\W+/g, '').slice(0, 24) || 'unknown';
      }
      pageId = pageId.replace(/Blog/gm, '');

      const tt = new Date();
      const dd = String(tt.getDate()).padStart(2, '0');
      const mm = String(tt.getMonth() + 1).padStart(2, '0');
      const hh = String(tt.getHours()).padStart(2, '0');
      const mi = String(tt.getMinutes()).padStart(2, '0');
      const resultsDate = dd + mm + hh + mi;

      const waba_medium = getCookie('waba_code') || '';
      const waba_campaign = getCookie('wabac_code') || '';

      const utmterm = url.searchParams.get('utm_term') || getCookie('utm_term') || '';
      const matchtype = url.searchParams.get('matchtype') || getCookie('matchtype') || '';
      const utermmatchtype = (utmterm || matchtype) ? ('.' + matchtype + '.' + utmterm) : '..';

      const channel = url.searchParams.get('channel') || '';
      const newJourney = pageId + '.' + resultsDate + '.' + waba_medium + waba_campaign + utermmatchtype;
      const journey = newJourney + '.' + channel;

      setCookie('user_journey', journey, 31);
      if (!getCookie('created_at')) {
        const dateCookie = new Date();
        dateCookie.setTime(dateCookie.getTime() + 31 * 24 * 60 * 60 * 1000);
        setCookie('created_at', dateCookie.toUTCString(), 31);
      }
    } catch (e) {
      // If this fast-path fails for any reason, fall back to the full computation.
      runAfterPaint();
    }
  };

  const ensureBeforeClick = () => {
    ensureJourneyCookieFast();
    // Defer the heavier refresh so it doesn't block the interaction.
    runAfterPaint();
  };

  // Fire on earliest user gesture to populate journey before click handlers.
  try { window.addEventListener('pointerdown', ensureBeforeClick, { capture: true, once: true, passive: true }); } catch (e) {}
  try { window.addEventListener('touchstart', ensureBeforeClick, { capture: true, once: true, passive: true }); } catch (e) {}
  try { window.addEventListener('keydown', ensureBeforeClick, { capture: true, once: true, passive: true }); } catch (e) {}

  // Fallback: also run soon after init.
  // This is async (won't block INP), and still populates cookies for passive visits.
  setTimeout(runAfterPaint, 0);
}
